import React, { useState } from 'react'
import { ConfigItem } from './ConfigItem'
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Col,
  Row,
  FormGroup,
  Form,
  Input,
  Button,
} from 'react-bootstrap'
//import Checkbox from 'components/atoms/@vuexy/checkbox/CheckboxesVuexy'
import { Checkbox, Radio,FormControlLabel } from '@mui/material'
import FeatherIcon from 'feather-icons-react'
import Select from 'react-select'
import { SketchPicker } from 'react-color'
//import { pick } from 'utility/common.util'
import _ from 'lodash'

const SIZE_OPTIONS = [
  {
    label: 'A4',
    value: 'A4',
    width: '21cm',
    height: '29.7cm',
    paddingLeft: '0.5in',
    paddingTop: '0.5in',
  },
  {
    label: 'A5',
    value: 'A5',
    width: '14.8cm',
    height: '21cm',
    paddingLeft: '0.5in',
    paddingTop: '0.5in',
  },
  { label: 'Letter', value: 'Letter', width: '8.5in', height: '11in' },
  { label: 'Custom', value: 'Custom' },
]

const FONT_SIZE_OPTIONS = [
  {label:'8',value:'font-8'},
  {label:'10',value:'font-10'},
  {label:'12',value:'font-12'},
  {label:'14',value:'font-14'},
  {label:'16',value:'font-16'},
  {label:'18',value:'font-18'},
  {label:'19',value:'font-19'},
  {label:'20',value:'font-20'},
  {label:'22',value:'font-22'},
  {label:'24',value:'font-24'},
  {label:'26',value:'font-26'},
  {label:'28',value:'font-28'},
  {label:'30',value:'font-30'},
]

const PAGES_OPTIONS = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
]

const FONT_WEIGHT_OPTIONS = [
  { label: 100, value: 100 },
  { label: 200, value: 200 },
  { label: 300, value: 300 },
  { label: 400, value: 400 },
  { label: 500, value: 500 },
  { label: 600, value: 600 },
  { label: 700, value: 700 },
  { label: 800, value: 800 },
]

const FONT_OPTIONS = [
  { label: 'Sarabun', value: 'sarabun' },
  { label: 'TH Sarabun New', value: 'THSarabunNew' },
  { label: 'Angsana New', value: 'angsana' },
  { label: 'Prompt', value: 'Prompt' },
]
const LayoutMenu = (props) => {
  const { layout } = props
  const [displayColorPicker, setDisplayColorPicker] = useState(false)

  const toggleDisplayColorPicker = () => {
    setDisplayColorPicker(!displayColorPicker)
  }
  const menu = [
    { name: 'Text' },
    { name: 'Image' },
    { name: 'Date' },
    { name: 'Checkbox' },
    { name: 'Barcode' },
    { name: 'Qrcode' },
    { name: 'Table' },
    { name: 'Report' },
  ]
  //const [state,setState] = useState({size:'A4',orientation:'landscape',width:'21cm',height:'29.7cm',marginLeft:'',marginRight:'',marginTop:'',marginBottom:''})
  const updateData = (field, value) => {
    //setState({ ...state, [field]: value })

    if (!value) {
      value = ''
    }

    let newLayout = { ...layout, [field]: value }
    if (field == 'size') {
      let index = SIZE_OPTIONS.findIndex((item) => item.value === value)
      if (index > -1 && SIZE_OPTIONS[index].width) {
        newLayout = Object.assign(
          newLayout,
          _.pick(SIZE_OPTIONS[index], [
            'width',
            'height',
            'paddingLeft',
            'paddingTop',
          ])
        )
      }
    }
    props.onChange(newLayout)
  }

  const toggleCheckbox = () => {
    let newValue = layout.orientation == 'landscape' ? 'portrait' : 'landscape'
    let newLayout = { ...layout, ['orientation']: newValue }
    let index = SIZE_OPTIONS.findIndex((item) => item.value === newLayout.size)
    if (newValue == 'landscape') {
      if (index > -1 && SIZE_OPTIONS[index].width) {
        let { width, height, paddingLeft, paddingTop } = SIZE_OPTIONS[index]
        newLayout = Object.assign(newLayout, {
          width: height,
          height: width,
          paddingBottom: paddingLeft,
          paddingLeft: paddingTop,
        })
      }
    } else {
      if (index > -1 && SIZE_OPTIONS[index].width) {
        newLayout = Object.assign(
          newLayout,
          _.pick(SIZE_OPTIONS[index], [
            'width',
            'height',
            'paddingLeft',
            'paddingTop',
          ])
        )
      }
    }
    props.onChange(newLayout)
  }

  const renderInput = (title, field) => {
    return (
      <FormGroup row>
        <Form.Label for="value" className="text-sm-right">
          {title}
        </Form.Label>
        <Form.Control
          type="text"
          name="value"
          value={layout[field]}
          onChange={(e) => updateData(field, e.target.value)}
        />
      </FormGroup>
    )
  }

  return (
    <div className="p-1">
      <FormGroup row className='col'>
          <FormControlLabel
            control={
              <Checkbox
                size="small" // Use 'small' instead of 'sm'
                color="primary"
                checked={layout.orientation == 'landscape'}
                onChange={(e) => toggleCheckbox()}
              />
            }
            label={'landscape'}
          />
     
      </FormGroup>

      <FormGroup row>
        <div>Pages</div>
        <div style={{ width: '100%' }}>
          <Select
            name="pages"
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            options={PAGES_OPTIONS}
            value={
              layout.pages && {
                label: layout.pages,
                value: layout.pages,
              }
            }
            onChange={(e) => {
              updateData('pages', e.value)
            }}
          />
        </div>
      </FormGroup>

      <FormGroup row>
        <div>Paper Size</div>
        <div style={{ width: '100%' }}>
          <Select
            name="size"
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            options={SIZE_OPTIONS}
            value={
              layout.size && {
                label: layout.size,
                value: layout.size,
              }
            }
            onChange={(e) => {
              updateData('size', e.value)
            }}
          ></Select>
        </div>
      </FormGroup>
      {renderInput('Width', 'width')}
      {renderInput('Height', 'height')}
      {renderInput('Margin-left', 'paddingLeft')}
      {renderInput('Margin-right', 'paddingRight')}
      {renderInput('Margin-top', 'paddingTop')}
      {renderInput('Margin-bottom', 'paddingBottom')}

      <FormGroup row>
        <div>Font</div>
        <div style={{ width: '100%' }}>
          <Select
            isClearable
            name="font"
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            options={FONT_OPTIONS}
            value={
              layout.fontFamily &&
              (FONT_OPTIONS.find((x) => x.value === layout.fontFamily) ?? null)
            }
            onChange={(e) => {
              updateData('fontFamily', e ? e.value : '')
            }}
          />
        </div>
      </FormGroup>
      <FormGroup row>
        <div>Font Size</div>
        <div style={{ width: '100%' }}>
          <Select
            isClearable
            name="fontSize"
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            options={FONT_SIZE_OPTIONS}
            value={
              layout.fontSize &&
              (FONT_SIZE_OPTIONS.find((x) => x.value === layout.fontSize) ?? null)
            }
            onChange={(e) => {
              updateData('fontSize', e ? e.value : '')
            }}
          />
        </div>
      </FormGroup>


      <FormGroup row>
        <div>Font Weight</div>
        <div style={{ width: '100%' }}>
          <Select
            isClearable
            name="font-weight"
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            options={FONT_WEIGHT_OPTIONS}
            value={
              layout.fontWeight && {
                label: layout.fontWeight,
                value: layout.fontWeight,
              }
            }
            onChange={(e) => {
              updateData('fontWeight', e ? e.value : '')
            }}
          />
        </div>
      </FormGroup>

      <FormGroup row>
        <div>Font Color</div>
        <div className="w-100">
          {!layout.color ? (
            <Button
              outline
              size="sm"
              color="primary"
              onClick={() => toggleDisplayColorPicker()}
            >
              Pick Color
            </Button>
          ) : (
            <div className="d-flex">
              <div
                className="mx-50"
                style={{
                  backgroundColor: layout.color,
                  width: 28,
                  hight: 28,
                  border: '1px solid lightgray',
                }}
                onClick={() => toggleDisplayColorPicker()}
              />
              <Button
                outline
                size="sm"
                color="primary"
                onClick={() => updateData('color', '')}
              >
                Reset
              </Button>
            </div>
          )}

          {displayColorPicker ? (
            <div style={{ position: 'absolute', zIndex: '2', marginTop: 10 }}>
              <div
                style={{
                  position: 'fixed',
                  top: '0px',
                  right: '0px',
                  bottom: '0px',
                  left: '0px',
                }}
                onClick={() => toggleDisplayColorPicker()}
              />
              <SketchPicker
                width={160}
                disableAlpha
                presetColors={[]}
                color={layout.color}
                onChange={(e) => {
                  updateData('color', e ? e.hex : '')
                }}
              />
            </div>
          ) : null}
        </div>
      </FormGroup>
    </div>
  )
}

export default LayoutMenu
